import * as R from 'ramda';

import { RoleType } from '../types/role-type';

import { AccessControlCapacity } from './access-control-capacity.model';

export enum RoleId {
  local = 19,
  fullAdmin = 21,
  nominator = 20,
  nominatorBackup = 244,
  conditionalBidder = 252,
  conditionalBidderBackup = 255,
  sales = 174,
}

/**
 * Model for API AccessControlRole Model
 */
export class AccessControlRole {
  id: number;

  /**
   * Role name
   * example: ROLE NAME
   */
  name: string;

  /**
   * example: api.alert.read
   */
  capacities: AccessControlCapacity[];

  /**
   * The type of the role
   */
  type: RoleType;

  description: string;

  constructor(attributes: Partial<AccessControlRole> = {}) {
    Object.assign(this, attributes);
  }

  equalTo(role: AccessControlRole): boolean {
    return this.id === role.id;
  }

  /**
   * A role X can grant a role Y, only if X contains, at least, all the capacities of role Y
   */
  canGrant(role: AccessControlRole): boolean {
    return (
      R.differenceWith(
        (a: AccessControlCapacity, b: AccessControlCapacity) => a.name === b.name,
        role.capacities || [],
        this.capacities || [],
      ).length === 0
    );
  }

  hasCapacity(capacity: AccessControlCapacity): boolean {
    return this.capacities.findIndex((c: AccessControlCapacity) => c.equalTo(capacity)) !== -1;
  }
}
